import React from "react";
import Navbar from "../navbar/Navbar";
import 'remixicon/fonts/remixicon.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import imagecanada from "../../assets/canada.png";
import imageuk from "../../assets/united-kingdom.png";
import imagefrance from "../../assets/france.png";
import imagegermany from "../../assets/germany.png";
import imageAus from "../../assets/australia.png";
import imageItaly from "../../assets/italy.png";
import imagenz from "../../assets/nz.png";
import imageSpain from "../../assets/spain.png";
import imagechina from "../../assets/china.png";
import imageOne from "../../assets/banner-1.jpg";
import imageusa from "../../assets/united-states.png";
import imageTwo from "../../assets/banner-2.jpg";
import imageThree from "../../assets/banner-3.jpg";
import imageCost from "../../assets/Cost-Effective.jpg";
import imageProcesser from "../../assets/Faster_Processing.jpg";
import imageInterview from "../../assets/Direct_Interviews.jpg";
import imageVisa from "../../assets/page-title-7.jpg";

import Footer from "../Footer/footer";

const Home = () => {
  return (
    <div>
      <Navbar />
      <div class="banner-section">
    <div id="carouselExampleCaptions" class="carousel slide" data-bs-ride="carousel">
      <div class="carousel-indicators">
        <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
        <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="1" aria-label="Slide 2"></button>
        <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="2" aria-label="Slide 3"></button>
      </div>
      <div class="carousel-inner">
        <div class="carousel-item active">
          <img src={imageOne} class="d-block w-100" alt="..."/>
          <div class="carousel-caption d-none d-md-block">
            <h5 class="display-4">Make your overseas dreams            </h5>
            <p>come true!</p>
          </div>
        </div>
        <div class="carousel-item">
          <img src={imageTwo} class="d-block w-100" alt="..."/>
          <div class="carousel-caption d-none d-md-block">
            <h5 class="display-4">Make your overseas dreams            </h5>
            <p>come true!</p>
          </div>
        </div>
        <div class="carousel-item">
          <img src={imageThree} class="d-block w-100" alt="..."/>
          <div class="carousel-caption d-none d-md-block">
            <h5 class="display-4">Make your overseas dreams            </h5>
            <p>come true!</p>
          </div>
        </div>
      </div>
      <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="prev">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Previous</span>
      </button>
      <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="next">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Next</span>
      </button>
    </div>
  </div>
      <div class="osc-section pt-5 pb-5">
        <div class="container-fluid">
          <div class="container">
            <div class="row">
              <div class="col-md-12">
                <div class="section-title">
                  <h2 class="display-5">
                    {" "}
                    Our successful <span class="text-c-2">700 Clients</span>...
                    <br />
                    Flyurdream here to help grow faster
                  </h2>
                </div>
                <p class="text-center">
                  Flyurdream is an IFlyurdream is an International Student
                  Recruitment Organization that assists students in pursuing
                  overseas education in universities in UK, USA, Australia, New
                  Zealand, Canada, Switzerland, etc. Flyurdream is a
                  solution-oriented company, which specializes in tailoring
                  career pathways to suit individual profiles within the
                  constraints that may prevail in each case. The constraints may
                  be educational, financial or personal.
                </p>
              </div>
            </div>
            <div class="row" >
              <div class="col-md-12">
                <ul class="osc-section-list">
                  <li>
                    <div class="shadow-sm p-4 mb-4  text-center" href="student">
                    <a className="icon-home" href="/student">
                      <i class="ri-user-2-fill"></i>
                      </a>
                      <h2 class="display-6">Students</h2>
                      {/* <p>
                        Dreaming of studying abroad? At FlyUrDream, we make your
                        international education journey{" "}
                      </p> */}
                      <a href="/student">
                        <i class="ri-arrow-right-double-line"></i>
                      </a>
                    </div>
                  </li>
                
                  <li>
                    <div class="shadow-sm p-4 mb-4  text-center" href="/recruitment-partner">
                    <a className="icon-home" href="/recruitment-partner">
                      <i class="ri-shake-hands-fill"></i>
                      </a>
                      <h2 class="display-6">Recruitment Partners</h2>
                      {/* <p>
                        Dreaming of studying abroad? At FlyUrDream, we make your
                        international education journey{" "}
                      </p> */}
                      <a href="/recruitment-partner">
                        <i class="ri-arrow-right-double-line"></i>
                      </a>
                    </div>
                  </li>
                 
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bct-section pt-5">
        <div class="container-fluid">
          <div class="container">
            <div class="section-title">
              <h6>Countries We Offer </h6>
              <h2 class="display-5"> Best Countries to Travel</h2>
            </div>
            <div class="row">
              <div class="tab-content" id="myTabContent">
                <div
                  class="tab-pane fade show active"
                  id="Education"
                  role="tabpanel"
                  aria-labelledby="Education-tab"
                >
                  <div>
                    <ul class="country-list">
                      <li>
                        <a>
                          <img src={imageusa} alt="" /> United
                          States
                        </a>
                      </li>
                      <li>
                        <a>
                          <img src={imagecanada} alt="" /> canada
                        </a>
                      </li>
                      <li>
                        <a>
                          <img src={imageuk} alt="" /> United
                          Kingdom
                        </a>
                      </li>
                      <li>
                        <a>
                          <img src={imagefrance} alt="" /> France
                        </a>
                      </li>
                      <li>
                        <a>
                          <img src={imagegermany} alt="" /> Germany
                        </a>
                      </li>
                      {/* <li>
                        <a href="javascript:void(0)">
                          <img src={imagechina} alt="" /> China
                        </a>
                      </li> */}
                      <li>
                        <a>
                          <img src={imageAus} alt="" />{" "}
                          Australia
                        </a>
                      </li>
                      <li>
                        <a>
                          <img src={imagenz} alt="" /> New Zealand
                        </a>
                      </li>
                      <li>
                        <a>
                          <img src={imageItaly} alt="" /> Italy
                        </a>
                      </li>
                      <li>
                        <a>
                          <img src={imageSpain} alt="" /> Spain
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div
                  class="tab-pane fade"
                  id="Travel"
                  role="tabpanel"
                  aria-labelledby="Travel-tab"
                >
                  <div>
                    <ul class="country-list">
                      <li>
                        <a>
                          <img src="images/united-states.png" alt="" /> United
                          States
                        </a>
                      </li>
                      <li>
                       <a>
                          <img src="images/canada.png" alt="" /> canada
                        </a>
                      </li>
                      <li>
                       <a>
                          <img src="images/united-kingdom.png" alt="" /> United
                          Kingdom
                        </a>
                      </li>
                      <li>
                       <a>
                          <img src="images/france.png" alt="" /> France
                        </a>
                      </li>
                      <li>
                       <a>
                          <img src="images/germany.png" alt="" /> Germany
                        </a>
                      </li>
                      {/* <li>
                       <a>
                          <img src="images/china.png" alt="" /> China
                        </a>
                      </li> */}
                      <li>
                       <a>
                          <img src="images/united-states.png" alt="" />{" "}
                          Australia
                        </a>
                      </li>
                      <li>
                       <a>
                          <img src="images/canada.png" alt="" /> New Zealand
                        </a>
                      </li>
                      <li>
                       <a>
                          <img src="images/united-kingdom.png" alt="" /> Italy
                        </a>
                      </li>
                      <li>
                       <a>
                          <img src="images/france.png" alt="" /> Spain
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="cr-section mt-5">
        <div class="container-fluid">
          <div class="container">
            <div class="section-title">
              <h6>Client Reviews</h6>
              <h2 class="display-5"> What our customers are saying</h2>
            </div>
            <div class="row">
              <div class="col-md-12 mb-4 ">
                <div
                  id="carouselExampleControls"
                  class="carousel slide"
                  data-bs-ride="carousel"
                >
                  <div class="row">
                    <div class="col-md-6 col-sm-6 col-6">
                      <button
                        class="carousel-control-prev border-1 shadow-sm "
                        type="button"
                        data-bs-target="#carouselExampleControls"
                        data-bs-slide="prev"
                      >
                        <span
                          class="carousel-control-prev-icon"
                          aria-hidden="true"
                        ></span>
                        <span class="visually-hidden">Previous</span>
                      </button>
                    </div>
                    <div class="col-md-6 col-sm-6 col-6">
                      <button
                        class="carousel-control-next border-1 shadow-sm "
                        type="button"
                        data-bs-target="#carouselExampleControls"
                        data-bs-slide="next"
                      >
                        <span
                          class="carousel-control-next-icon"
                          aria-hidden="true"
                        ></span>
                        <span class="visually-hidden">Next</span>
                      </button>
                    </div>
                  </div>

                  <div class="carousel-inner">
                    <div class="carousel-item active">
                      <div class="row ">
                        <div class="col-md-6 ">
                          <div class="border shadow-sm p-4 bg-white">
                            Extremely professional in matter of response and
                            have more than sufficient knowledge on most
                            country’s universities and if not, they’ll look up
                            on all the important information in no matter ...
                          </div>
                          <div class="text-end pt-2">Muhammad Ali</div>
                        </div>

                        <div class="col-md-6">
                          <div class="border shadow-sm p-4 bg-white">
                            Extremely professional in matter of response and
                            have more than sufficient knowledge on most
                            country’s universities and if not, they’ll look up
                            on all the important information in no matter ...
                          </div>
                          <div class="text-end pt-2">Abdullah Farhan</div>
                        </div>
                      </div>
                    </div>
                    <div class="carousel-item">
                      <div class="row ">
                        <div class="col-md-6 ">
                          <div class="border shadow-sm p-4 bg-white">
                            Extremely professional in matter of response and
                            have more than sufficient knowledge on most
                            country’s universities and if not, they’ll look up
                            on all the important information in no matter ...
                          </div>
                          <div class="text-end pt-2">Shaik Ahmed</div>
                        </div>

                        <div class="col-md-6">
                          <div class="border shadow-sm p-4 bg-white">
                            Extremely professional in matter of response and
                            have more than sufficient knowledge on most
                            country’s universities and if not, they’ll look up
                            on all the important information in no matter ...
                          </div>
                          <div class="text-end pt-2">Muhammad Ali</div>
                        </div>
                      </div>
                    </div>
                    <div class="carousel-item">
                      <div class="row ">
                        <div class="col-md-6 ">
                          <div class="border shadow-sm p-4 bg-white">
                            Extremely professional in matter of response and
                            have more than sufficient knowledge on most
                            country’s universities and if not, they’ll look up
                            on all the important information in no matter ...
                          </div>
                          <div class="text-end pt-2">Abdullah Farhan</div>
                        </div>

                        <div class="col-md-6">
                          <div class="border shadow-sm p-4 bg-white">
                            Extremely professional in matter of response and
                            have more than sufficient knowledge on most
                            country’s universities and if not, they’ll look up
                            on all the important information in no matter ...
                          </div>
                          <div class="text-end pt-2">Shaik Ahmed</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="wcu pt-5 pb-5">
        <div class="container-fluid">
          <div class="container">
            <div class="row">
              <div class="col-md-6 col-sm-12">
                <h6>Why Choose Us</h6>
                <h1 class="pt-3 pb-3 display-5">
                  Offer Tailor Made Services That Our Client Requires
                </h1>
                <ul class="nav nav-tabs" id="myTab" role="tablist">
                  <li class="nav-item" role="presentation">
                    <button
                      class="nav-link active"
                      id="DirectInterviews-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#DirectInterviews"
                      type="button"
                      role="tab"
                      aria-controls="DirectInterviews"
                      aria-selected="true"
                    >
                      <i class="ri-team-line"></i>
                    </button>
                  </li>
                  <li class="nav-item" role="presentation">
                    <button
                      class="nav-link"
                      id="FasterProcessing-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#FasterProcessing"
                      type="button"
                      role="tab"
                      aria-controls="FasterProcessing"
                      aria-selected="false"
                    >
                      <i class="ri-id-card-line"></i>
                    </button>
                  </li>
                  <li class="nav-item" role="presentation">
                    <button
                      class="nav-link"
                      id="VisaAssistance-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#VisaAssistance"
                      type="button"
                      role="tab"
                      aria-controls="VisaAssistance"
                      aria-selected="false"
                    >
                      <i class="ri-flight-takeoff-line"></i>
                    </button>
                  </li>
                  <li class="nav-item" role="presentation">
                    <button
                      class="nav-link"
                      id="CostEffective-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#CostEffective"
                      type="button"
                      role="tab"
                      aria-controls="CostEffective"
                      aria-selected="false"
                    >
                      <i class="ri-money-rupee-circle-line"></i>
                    </button>
                  </li>
                </ul>
              </div>
              <div class="col-md-6 col-sm-12">
                <div class="tab-content" id="myTabContent">
                  <div
                    class="tab-pane fade show active"
                    id="DirectInterviews"
                    role="tabpanel"
                    aria-labelledby="DirectInterviews-tab"
                  >
                    <div>
                      <h2 class="display-6">Direct Interviews</h2>
                      <img
                        src={imageInterview}
                        alt="Direct Interviews"
                        class="img-fluid"
                      />
                      <p class="pt-3">
                        Our team comprises experienced professionals who are
                        passionate about education and dedicated to student
                        success. With backgrounds in international education,
                        counseling, and admissions, our advisors are equipped to
                        provide insightful guidance tailored to each student’s
                        unique needs.
                      </p>
                      <a  class="Explore">
                        <i class="ri-arrow-right-double-line"></i> Explore
                      </a>
                    </div>
                  </div>
                  <div
                    class="tab-pane fade"
                    id="FasterProcessing"
                    role="tabpanel"
                    aria-labelledby="FasterProcessing-tab"
                  >
                    <div>
                      <h2 class="display-6">Faster Processing</h2>
                      <img
                        src={imageProcesser}
                        alt="Faster Processing"
                        class="img-fluid"
                      />
                      <p class="pt-3">
                        Our team comprises experienced professionals who are
                        passionate about education and dedicated to student
                        success. With backgrounds in international education,
                        counseling, and admissions, our advisors are equipped to
                        provide insightful guidance tailored to each student’s
                        unique needs.
                      </p>
                      <a  class="Explore">
                        <i class="ri-arrow-right-double-line"></i> Explore
                      </a>
                    </div>
                  </div>
                  <div
                    class="tab-pane fade"
                    id="VisaAssistance"
                    role="tabpanel"
                    aria-labelledby="VisaAssistance-tab"
                  >
                    <div>
                      <h2 class="display-6">Visa Assistance</h2>
                      <img
                       src={imageVisa}
                        alt="Visa Assistance"
                        class="img-fluid"
                      />
                      <p class="pt-3">
                        Our team comprises experienced professionals who are
                        passionate about education and dedicated to student
                        success. With backgrounds in international education,
                        counseling, and admissions, our advisors are equipped to
                        provide insightful guidance tailored to each student’s
                        unique needs.
                      </p>
                      <a  class="Explore">
                        <i class="ri-arrow-right-double-line"></i> Explore
                      </a>
                    </div>
                  </div>
                  <div
                    class="tab-pane fade"
                    id="CostEffective"
                    role="tabpanel"
                    aria-labelledby="CostEffective-tab"
                  >
                    <div>
                      <h2 class="display-6">Cost-Effective</h2>
                      <img
                        src={imageCost}
                        alt="Cost-Effective
                    "
                        class="img-fluid"
                      />
                      <p class="pt-3">
                        Our team comprises experienced professionals who are
                        passionate about education and dedicated to student
                        success. With backgrounds in international education,
                        counseling, and admissions, our advisors are equipped to
                        provide insightful guidance tailored to each student’s
                        unique needs.
                      </p>
                      <a  class="Explore">
                        <i class="ri-arrow-right-double-line"></i> Explore
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Home;
